import { ApplicationContext } from '../model';

export const API_ENDPOINTS = {
  clientUserRoles: {
    GetClientUserRole: '/breeze/GetClientUserRole', // Not used. Remove later 
  },
  header: {
    GetReturnsDueCount: '/api/Return/GetReturnsDueCount',
  },
  inputSheet: {
    translatedData:`/api/Workpaper/GetTranslatedData`,
    bucketReportData: `/api/Workpaper/GetBucketReportData`,
    paymentExtractData: `/api/Workpaper/GetPaymentExtractData`,
    historyByReturnData: `/api/Workpaper/GetHistoryByReturn`,
    historyByStateData: `/api/Workpaper/GetHistoryByState`,
    creditBalanceHistoryReportData: `/api/Workpaper/GetCreditBalanceHistoryReportData`,
    creditCarryForward:'/api/Workpaper/GetCreditCarryForwardData',
    taxColNotRegistered:'/api/Workpaper/GetTaxColNotRegisteredData',
    // Reporting Group variants
    rgTranslatedData: `/api/Workpaper/GetTranslatedDataForRG`,
    rgBucketReportData: `/api/Workpaper/GetBucketReportDataForRG`,
    rgPaymentExtractData: `/api/Workpaper/GetPaymentExtractDataForRG`,
    rgHistoryByReturnData: `/api/Workpaper/GetHistoryByReturnForRG`,
    rgHistoryByStateData: `/api/Workpaper/GetHistoryByStateForRG`,
    rgCreditBalanceHistoryReportData: `/api/Workpaper/GetCreditBalanceHistoryReportDataForRG`,
    rgCreditCarryForward: '/api/Workpaper/GetCreditCarryForwardDataForRG',
    rgTaxColNotRegistered: '/api/Workpaper/GetTaxColNotRegisteredDataForRG',
    rgReconSheetData: '/api/Workpaper/GetReconSheetLoadDataForRG',
  },
  anybillSheet: {
    anybillReturnsData: (appContext: ApplicationContext): string =>
      `/api/Workpaper/GetAnybillReturnData?clientId=${appContext.clientId}&entityId=${appContext.entityId}&clientTaxPeriodId=${appContext.clientTaxPeriodId}`,
    anybillEncryptAndPay: `/api/Workpaper/AnybillEncryptAndPay`,
    triggerGeneratePaymentsXml: `/api/Workpaper/TriggerGeneratePaymentsXml`,
  },
  returnCalendar: {
    getReturns: `/api/Workpaper/GetReturnsCalenderData`,
    getReturnsForRG: `/api/Workpaper/GetReturnsCalenderDataForRG`,
  },
  reviewNotes: {
    getUsers: `/api/Admin/GetUsers`,
    getReviewNotes: `/api/Workpaper/GetReviewNotes`,
    createReviewNotes: `/api/Workpaper/CreateReviewNotes`,
    updateReviewNote: `/api/Workpaper/UpdateReviewNote`,
    resolveOrDeleteReviewNote: `/api/Workpaper/ResolveOrDeleteReviewNote`,
    // Reporting Group variants
    getReviewNotesForRG: `/api/Workpaper/GetReviewNotesForRG`,
    createReviewNotesForRG: `/api/Workpaper/CreateReviewNotesForRG`,
    updateReviewNoteForRG: `/api/Workpaper/UpdateReviewNoteForRG`,
    resolveOrDeleteReviewNoteForRG: `/api/Workpaper/ResolveOrDeleteReviewNoteForRG`,
  },
  common: {
    uploadfile: `api/Files/upload`,
    GetRefreshStatus: `/api/Workpaper/GetLastRefreshStatus`,
    GetRefreshStatusForRG: `/api/Workpaper/GetLastRefreshStatusForRG`,
  },
  workpaperConfig:{
    getWorkpaperPassword:'/api/AzureKeyVaultSecrets/GetSecretsFromKeyVault',
  },
  user: {
    getUserContextWithPermissionsAndRoles: '/api/User/GetUserContextWithPermissionsAndRoles',
    getAccessInfo: '/api/Workpaper/GetAccessInfo',
    getRGAccessInfo: '/api/Workpaper/GetRGAccessInfo',
  },
};
